<ion-menu menuId="boulder-list-details-menu" content-id="boulder-list-content">
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="end">
        <ion-menu-toggle>
          <ion-icon class="close-button" size="big" name="close-outline"></ion-icon>
        </ion-menu-toggle>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding">
    <ion-item (click)="showRanking()" [detail]="true">
      <ion-icon aria-hidden="true" name="trophy-outline" slot="start"></ion-icon>
      <ion-label>{{'boulder-list-details-page.list-ranking' | translate}}</ion-label>
    </ion-item>
    <ion-item *ngIf="isOwnList" (click)="renameList()" [detail]="true">
      <ion-icon aria-hidden="true" name="create-outline" slot="start"></ion-icon>
      <ion-label>{{'boulder-list-details-page.rename-list' | translate}}</ion-label>
    </ion-item>
    <ion-item *ngIf="isOwnList && !boulderList?.isProjectList" (click)="removeList()" [detail]="true">
      <ion-icon aria-hidden="true" name="trash" slot="start"></ion-icon>
      <ion-label>{{'boulder-list-details-page.delete-list' | translate}}</ion-label>
    </ion-item>
    <ion-item *ngIf="isOwnList">
      <ion-toggle [(ngModel)]="publicList" (ngModelChange)="publicToggleChanged()" justify="end"
                  [color]="publicList?'primary':'lightGrey'">{{"boulder-list-details-page.public" | translate}}</ion-toggle>
    </ion-item>
  </ion-content>
</ion-menu>
<ion-header *ngIf="boulderList">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button></ion-back-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-menu-button menu="boulder-list-details-menu"></ion-menu-button>
    </ion-buttons>
    <ion-title>{{boulderList.name}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content id="boulder-list-content">
  <ion-button class="full-width" *ngIf="boulders?.length===4" (click)="start4x4()">
    {{'boulder-list-details-page.start-4x4' | translate}}
    <ion-icon name="stopwatch-outline" slot="start"></ion-icon>
  </ion-button>
  <p *ngIf="boulderList && !isOwnList">{{"boulder-list-details-page.list-by" | translate}} {{boulderList.author}}</p>
  <p *ngIf="!isLoading && boulders.length===0">{{"boulder-list-details-page.empty" | translate}}</p>
  <ion-reorder-group (ionItemReorder)="doReorder($event)" disabled="false">
    <ion-item-sliding *ngFor="let boulder of boulders">
      <ion-item>
        <app-boulder-list-entry [boulder-list-entry]="boulder" (click)="showBoulder(boulder)"></app-boulder-list-entry>
        <ion-reorder slot="end" *ngIf="isOwnList"></ion-reorder>
      </ion-item>
      <ion-item-options>
        <ion-item-option color="danger"
                         (click)="removeBoulderFromList(boulder.boulderId)">{{'shared.remove' | translate}}</ion-item-option>
      </ion-item-options>
    </ion-item-sliding>
  </ion-reorder-group>
  <loader *ngIf="isLoading"></loader>
</ion-content>
